import gaUtils from '@/components/GAWrapper/GAWrapper'
import branchUtils from '@/utils/branchUtils'
import { publish } from '@/utils/events'

export const authAnalytics = {
  onLoginSuccess (userData) {
    const user = userData?.user || userData
    if (user?.id) {
      gaUtils.trackUserId(user.id)
      gaUtils.setEnhancedUserData(user)
    }
    gaUtils.trackUserLogin()
    publish('checkPopupBonuses')
  },

  onRegisterSuccess (responseData) {
    const user = responseData.user
    gaUtils.trackSuccessfullRegister()
    gaUtils.trackUserId(user.id)
    gaUtils.setEnhancedUserData(user)
    branchUtils.setUserId(user.id)
    branchUtils.sendEvent('COMPLETE_REGISTRATION', {})
  },

  onAuthComplete (data) {
    publish('updateUserInfo', data)
    publish('LOGIN_SUCCESS', data)
  },
}
